import {
    hideLink1,
    hideLink2,
    hideLink3,
    hideLink4,
    hideLink5
} from '../../utils/website.utils'

const ProfileDocuments = ({ t }) => {
    return (
        <div>
            <div className="container-fluid">
                <div className="row">
                    <div className="dashboard-content-header">
                        <h1>{t('insurance.h1')}</h1>
                    </div>
                </div>
                <div className="row">
                <div className="dashboard-content-header">
                        <div className="col-xs-12 col-sm-12 col-lg-12" style={{padding: 0, fontWeight: 600}}>
                            <div className="panel panel-default" style={{margin: 0}}>
                                <div className="panel-heading" style={{display: 'flex'}}>
                                    <h3 className="panel-title" style={{marginLeft: 16}}>{t('insurance.h4')}</h3>
                                </div>
                                <div className="panel-body" style={{ maxHeight: '200px', padding: '5px 5px', marginTop: 10 }}>
                                    <p style={{marginLeft: 16}}>{t('insurance.h5')}</p>
                                    <div className="dashboard-tax-content" style={{marginLeft: 16}}>
                                        <ul style={{ listStyleType: 'none' }}>
                                            <li>
                                                <a
                                                    onClick={hideLink3}
                                                    style={{ cursor: 'pointer' }}
                                                    target="_blank"
                                                >
                                                    {t('insurance.body3')}
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    onClick={hideLink4}
                                                    style={{ cursor: 'pointer' }}
                                                    target="_blank"
                                                >
                                                    {t('insurance.body4')}
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    onClick={hideLink5}
                                                    style={{ cursor: 'pointer' }}
                                                    target="_blank"
                                                >
                                                    {t('insurance.body5')}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="dashboard-content-header">
                        <div className="col-xs-12 col-sm-12 col-lg-12" style={{padding: 0, fontWeight: 600}}>
                            <div className="panel panel-default" style={{margin: 0}}>
                                <div className="panel-heading" style={{display: 'flex'}}>
                                    <h3 className="panel-title" style={{marginLeft: 16}}>{t('insurance.h2')}</h3>
                                </div>
                                <div className="panel-body" style={{ maxHeight: '200px', padding: '5px 5px', marginTop: 10 }}>
                                    <p style={{marginLeft: 16}}>{t('insurance.h3')}</p>
                                    <div className="dashboard-tax-content" style={{marginLeft: 16}}>
                                        <ul style={{ listStyleType: 'none' }}>
                                            <li>
                                                <a
                                                    onClick={hideLink1}
                                                    style={{ cursor: 'pointer' }}
                                                    target="_blank"
                                                >
                                                    {t('insurance.body1')}
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    onClick={hideLink2}
                                                    style={{ cursor: 'pointer' }}
                                                    target="_blank"
                                                >
                                                    {t('insurance.body2')}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ProfileDocuments
